import { UseQueryOptions, QueryKey, useQuery } from '@tanstack/react-query';
import { fetchAllArcgisFeatures } from '@/lib/arcgis';

const max50Key = ['50Max'];

const get50MaxData = async (): Promise<GeoJSON.FeatureCollection[]> => {
  const urls = [
    'https://services.arcgis.com/CXBb7LAjgIIdcsPt/ArcGIS/rest/services/50Max_RoadRestrictions/FeatureServer/1/query?where=1%3D1&outFields=*&f=geojson',
    'https://services.arcgis.com/CXBb7LAjgIIdcsPt/ArcGIS/rest/services/50Max_RoadRestrictions/FeatureServer/2/query?where=1%3D1&outFields=*&f=geojson',
    'https://services.arcgis.com/CXBb7LAjgIIdcsPt/ArcGIS/rest/services/50Max_RoadRestrictions/FeatureServer/3/query?where=1%3D1&outFields=*&f=geojson',
    'https://services.arcgis.com/CXBb7LAjgIIdcsPt/ArcGIS/rest/services/50Max_RoadRestrictions/FeatureServer/4/query?where=1%3D1&outFields=*&f=geojson',
  ];

  return Promise.all(urls.map((url) => fetchAllArcgisFeatures(url)));
};

export const use50Max = (
  options?: Omit<
    UseQueryOptions<any[], Error, any[], QueryKey>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    queryKey: max50Key,
    queryFn: get50MaxData,
    staleTime: Infinity,
    ...options,
  });
